import Vue from "vue"
import VueProgressBar from "vue-progressbar"

Vue.use(VueProgressBar, {
    autoFinish: false
})